module.exports = __webpack_public_path__ + "img/success.0b073df6.png";